module.exports = __webpack_public_path__ + "img/GlobalAwardsAssetHub.5ed56eb1.svg";